export const ADD_TO_CART_EVENT_NAME = 'addToCartEvent'

// 
export const createAddToCartEvent = ()  => new Event(ADD_TO_CART_EVENT_NAME)